import React from "react";
import { useTranslation } from "react-i18next";

import { Checkbox, ListItemText, Select, MenuItem } from "@mui/material";

export default function Status(props) {
    const { t } = useTranslation("translation");
    return (
        <Select id="status" multiple label={t("Status")} value={props.status} renderValue={(selected) => props.selectedStatusName.join(", ")} onChange={props.HandleStatus} size={props.size ?? "normal"}>
            {props.statusData.map((data, index) => (
                <MenuItem key={data.id} value={data.code} id={`status_MenuItem_${index}`}>
                    <Checkbox checked={props.status.indexOf(data.code) > -1} id={`status_Checkbox_${index}`} />
                    <ListItemText primary={data.description} id={`status_ListItemText_${index}`} />
                </MenuItem>
            ))}
        </Select>
    );
}
